export default "__VITE_ASSET__17690500__"